import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Box, Text, Button } from 'grommet';
import { DocumentText, Java, Trash } from 'grommet-icons';

import { Placeholder, ErrorsSearches, Tag } from '../../../../components';
import { toggleFormDeleteLayer } from '../../actions/form-delete';
import { showFormManagerLayer } from '../../actions/form-manager';

const SearchResult = (props) => {
  const {
    loadingFormSearch,
    dataRows,
    getListError,

    toggleFormDeleteLayer,
    showFormManagerLayer,
  } = props;

  if(loadingFormSearch && !getListError) {
    return (
      <Placeholder
        title='Carregando...'
        message='Aguarde que estamos preparando as coisas :)'
      />
    );
  }

  if(getListError) {
    return <ErrorsSearches />;
  }

  return (
    <ResponsiveContext.Consumer>
      {size => {
        return (
          <Box
            direction='row'
            justify='center'
            margin={{ horizontal: 'medium', top: '100px' }}
          >
            <Box
              pad='small'
              width='xlarge'
              gap='medium'
            >
              {/* Cabeçalho */}
              <Box
                direction='row'
                gap='xsmall'
                align='baseline'
              >
                <Text size='large' color='dark-5'>Configure o</Text>
                <Text size='xlarge' color='dark-1'>envio automático de mensagem</Text>
              </Box>

              {/* Conteúdo */}
              <Box
                gap='medium'
                direction={ size === 'small' || size === 'medium' ? 'column' : 'row' }
                justify='between'
              >

                {/* Primeira coluna */}
                <Box
                  width={
                    size === 'small' || size === 'medium' ? 'xlarge' : 'xlarge'
                  }
                  gap='medium'
                >
                  <Text color='dark-2' size='small'>
                    O envio automático de mensagens facilita o seu dia a dia e fortalece o vínculo com quem mais importa.
                  </Text>

                  <Box
                    direction='row'
                    gap={ size === 'small' ? 'large' : 'medium' }
                    margin={{ bottom: size === 'small' ? 'large' : 'medium' }}
                  >
                    <Box
                      gap={ size === 'small' ? 'medium' : 'small' }
                      align='baseline'
                      width='50vw'
                    >
                      <DocumentText size='medium' color='brand' />

                      <Text size='small' color='dark-2' weight='bold'>
                        Flexibilidade
                      </Text>

                      <Text size='small' color='dark-2'>
                        Escolha entre vários templates já prontos para usar.
                      </Text>
                    </Box>

                    <Box
                      gap={ size === 'small' ? 'medium' : 'small' }
                      align='baseline'
                      width='50vw'
                    >
                      <Java size='medium' color='brand' />

                      <Text size='small' color='dark-2' weight='bold'>
                        Tranquilidade
                      </Text>

                      <Text size='small' color='dark-2'>
                        Mais tempo para focar em outras tarefas.
                      </Text>
                    </Box>
                  </Box>


                  <Button
                    primary
                    color='neutral-1'
                    label='Configurar comunicação automática'
                    disabled={!!dataRows.length}
                    onClick={
                      () => showFormManagerLayer()
                    }
                  />
                </Box>

                {/* Separador coluna */}
                <Box
                  width={ size === 'large' || size === 'xlarge' ? 'xsmall' : 'xxsmall' }
                />

                {/* Segunda coluna */}
                <Box
                  gap='small'
                  width={ size === 'small' || size === 'medium' ? 'xlarge' : 'xlarge' }
                >
                  {!!dataRows.length && (
                    <Box
                      round='small'
                      border={{ color: 'light-4' }}
                      background='white'
                    >
                      {dataRows.map(row => (
                          <Box
                            key={row.id}
                            align='center'
                            direction='row'
                            pad={{
                              horizontal: size === 'small' ? 'large' : 'medium',
                              vertical: size === 'small' ? 'medium' : 'small'
                            }}
                            border={{ color: 'light-3', side: 'top' }}
                            justify='between'
                            gap='large'
                          >
                            <Box
                              align='start'
                            >
                              <Text color='dark-2' size='medium'>Comunicação automática de <strong>{row.category}</strong></Text>

                              <Text
                                color='dark-4'
                                size='xsmall'
                              >
                                enviar por <strong>{row.type}</strong>
                              </Text>

                              <Tag
                                text={row.status ? 'Ativo' : 'Inativo'}
                                background={'status-ok'}
                                textSize='xsmall'
                              />
                            </Box>

                            <Box
                              align='end'
                            >
                              <Button
                                title='Excluir'
                                icon={<Trash color='status-error' size='medium' />}
                                onClick={() => { toggleFormDeleteLayer(row) }}
                              />
                            </Box>

                          </Box>
                        )
                      )}
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        )
      }}
    </ResponsiveContext.Consumer>
  )
}

const mapStateToProps = ({ settingsAutoCommunicationReducer: { searchResult } }) => ({
  loadingFormSearch: searchResult.loadingFormSearch,
  dataRows: searchResult.dataRows,
  getListError: searchResult.getListError,
});

const mapDispatchToProps = dispath => {
  return bindActionCreators({
    toggleFormDeleteLayer,
    showFormManagerLayer,
  }, dispath)
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SearchResult)
);
